import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TourOneListItem from './tab-views/tour-one/TourOneListItem';
import TourThreeListItem from './tab-views/tour-three/TourThreeListItem';
import TourTwoListItem from './tab-views/tour-two/TourTwoListItem';
import TourFourListItem from './tab-views/tour-four/TourFourListItem';
import TourService from '../../../services/TourService';

interface TourListProps {
}

var service = new TourService();
const TourList: React.FC<TourListProps> = ({ }) => {
    const { t } = useTranslation();

    const tour1 = service.tours.find(t => t.id === 1);
    const tour2 = service.tours.find(t => t.id === 2);
    const tour3 = service.tours.find(t => t.id === 3);
    const tour4 = service.tours.find(t => t.id === 4);

    if (tour1 === undefined || tour2 === undefined || tour3 === undefined || tour4 === undefined) {
        return null;
    }

    return (
        <Grid
            sx={{
                background: "radial-gradient(circle at top, rgba(223, 92, 45, 0.16), transparent 34%), linear-gradient(180deg, rgba(20, 22, 24, 0.86), rgba(12, 14, 15, 0.94))",
            }}
            pt={{ xs: 4, md: 6 }}
            pb={{ xs: 5, md: 7 }}
            container
            direction={"column"}
            alignItems={"center"}
            width={"100%"}>
            <Typography
                variant='h3'
                fontWeight={800}
                color={"#f4f5f7"}
                textAlign={"center"}
                sx={{
                    position: "relative",
                    pb: 1.5,
                    textShadow: "#000000ff 1px 0 10px",
                    "&::after": {
                        content: '""',
                        position: "absolute",
                        left: "50%",
                        bottom: 0,
                        width: 78,
                        height: 3,
                        borderRadius: 999,
                        transform: "translateX(-50%)",
                        background: "linear-gradient(90deg, transparent, #df5c2d, transparent)"
                    }
                }}>
                {t("tour.title")}
            </Typography>
            <Box
                mt={{ xs: 3, md: 4 }}
                display={"grid"}
                flexDirection={"row"}
                justifyContent={"center"}
                alignItems={"center"}
                flexWrap={"wrap"}
                gridTemplateColumns={{ xs: "repeat(1, 1fr) !important", sm: "repeat(2, 1fr) !important", md: "repeat(2, 1fr) !important", lg: "repeat(4, 1fr) !important" }}
                p={{ xs: 1.5, md: 2 }}
                px={{ xs: 2, md: 5 }}
                gap={{ xs: 3, md: 4 }}
                width={"100%"}>
                <TourOneListItem tour={tour1} />
                <TourTwoListItem tour={tour2} />
                <TourThreeListItem tour={tour3} />
                <TourFourListItem tour={tour4} />
            </Box>
        </Grid >
    )
}

export default TourList;